import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'
import { isNullOrUndefined } from '../../../../util/Utils'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'

export default () => {}

export function BirthDateChangeReservationsMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId
  const contributorIdOfChange = messageDetails?.contributorIdOfChange
  const contributorIdOfReservation = messageDetails?.contributorIdOfReservation
  const contributorChangedBirthDate = messageDetails?.contributorChangedBirthDate

  const personSummary = queueCachesState.personsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]
  const userChangeSummary = queueCachesState.usersCache[contributorIdOfChange]
  const userReservationSummary = queueCachesState.usersCache[contributorIdOfReservation]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    const uniqueContributorIds = [...new Set([contributorId, contributorIdOfChange, contributorIdOfReservation])]
    uniqueContributorIds.map((id) => queueCachesActions.fetchUserSummary(id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contributorId, contributorIdOfChange, contributorIdOfReservation, personId])

  if (
    isNullOrUndefined(personSummary) ||
    isNullOrUndefined(userSummary) ||
    isNullOrUndefined(userChangeSummary) ||
    isNullOrUndefined(userReservationSummary)
  ) {
    return null
  }

  return (
    <Grid>
      <Cell columns={6}>
        <DataBlock
          heading={t('personId', 'Person ID')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={
            <UserLink
              userId={contributorId}
              userName={userSummary?.contactName}
              country={userSummary?.country}
              showId
              newTab
            />
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributorIdOfChange', 'Contributor ID of Change')}
          data={
            <UserLink
              userId={contributorIdOfChange}
              userName={userChangeSummary?.contactName}
              country={userChangeSummary?.country}
              showId
              newTab
            />
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributorIdOfReservation', 'Contributor ID of Reservation')}
          data={
            <UserLink
              userId={contributorIdOfReservation}
              userName={userReservationSummary?.contactName}
              country={userReservationSummary?.country}
              showId
              newTab
            />
          }
        />
      </Cell>
      <Cell columns={12}>
        <DataBlock
          heading={t('contributorChangedBirthDate', 'Contributor Changed Birth Date')}
          data={contributorChangedBirthDate ? t('yes', 'Yes') : t('no', 'No')}
        />
      </Cell>
    </Grid>
  )
}
